export default __webpack_public_path__ + "static/media/093-diagonal-arrow-12.5317740c.png";